import { useQuery } from 'react-query';
import { APIErrorType } from '../../api';
import { fetchPackages, PackageType } from '../../api/package';
import { UseQueryResult } from 'react-query/types/react/types';

export type usePackagesReturnType = UseQueryResult<PackageType[]>;

export function usePackages(search: string): usePackagesReturnType {
  return useQuery<PackageType[], APIErrorType, PackageType[], [string, string]>(
    ['packages', search],
    fetchPackages
  );
}
